<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar" class="search-btn">
        <div>
          <el-button
            v-access:add
            icon="el-icon-plus"
            @click="add"
            size="small"
            :disabled="isloading"
            style="margin-top: 12px"
            type="danger"
            >新增
          </el-button>
          <el-button
            v-access:delete
            icon="el-icon-delete"
            size="small"
            :disabled="isDelete"
            @click="batchDel"
            style="margin-top: 12px"
            >删除
          </el-button>
        </div>
      </div>
      <div slot="searchBar">
        <OfSearch @search="search"></OfSearch>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
          @selection-change="onSelectionChange"
        >
          <el-table-column
            type="selection"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="Name"
            label="红十字会名称"
            align="left"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="Contacts"
            label="联系人"
            align="left"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="Phone"
            label="电话号码"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="Address"
            label="地址"
            
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-button
                v-access:delete
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/basics/connection/edit";
// import {
//   queryRC_Connection,
//   deleteRC_Connection
// } from "@/modules/yjrc/api/rc_connection.js";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      isDelete: true,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formTitle: "",
      formData: {},
      batchId: "",

      total: 0,
      currentPage: 1,
      pageSize: 15,
      sortOrder: "asc",
      searchFields: "DonationPerson", //搜索字段
      searchFilter: {
        keywords: "",
      },
      //ReturnFields:'audit_info'
    };
  },
  methods: {
    loadData(TypeId) {
      this.isloading = true;
      this.formData = {
        TypeId: TypeId || "",
      };
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        sortOrder: this.sortOrder,
        fastSearchFields: this.searchFields,
        fastSearchKeyWord: this.searchFilter.keywords,
        ReturnFields: this.ReturnFields,
      };
      api.QueryConnection(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;

          window.console.log(this.listData);
        }
        this.isloading = false;
      });
    },
    add() {
      (this.formTitle = "新增红十字会信息"), (this.formData = {});
      this.formVisible = true;
      this.formData.Creator = this.GetCurrentUserInfo.RealName;
      this.formData.CreatorId = this.GetCurrentUserInfo.Id;
    },
    batchDel() {
      this.innerDel({ Id: this.batchId });
    },
    search(keyword) {
      this.searchFilter.keywords = keyword;
      this.currentPage = 1;
      this.loadData();
    },
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData);
      this.edit();
    },
    edit() {
      (this.formTitle = "修改新增红十字会信息"), (this.formVisible = true);
    },
    innerDel(rowData) {
      window.console.log(rowData);
      this.$confirm("请确认是否删除选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api
          .DeleteConnection(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
    formCallBack(data) {
      this.formVisible = false;
      if (data != null) {
        this.loadData();
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 213;
      }
      return tableMaxHeight;
    },
    onSelectionChange(rowItems) {
      this.isDelete = !rowItems.length > 0;
      if (rowItems.length) {
        const ids = [];
        for (var i = 0; i < rowItems.length; i++) {
          ids.push(rowItems[i].Id);
        }
        this.batchId = ids.join(",");
      }
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
</style>
